import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type InclusionAgentPatientStatus = "suggested_to_doc" | "patient_accepted";

export type BaseInclusionAgentInfo = {
  id: string;
  firstName: string;
  lastName: string;
  libreviewId: string;
  email?: string;
  phoneNumber?: string;
};

export type InclusionAgentDocSuggestion = BaseInclusionAgentInfo & {
  status: "suggested_to_doc";
  tbr?: number;
  tir?: number;
  cv?: number;
  gmi?: number;
  hypo_count?: number;
};

export type InclusionAgentStatKey = "tbr" | "tir" | "cv" | "gmi" | "hypo_count";

export const inclusionAgentStatTranslationMapping = (key: InclusionAgentStatKey): string => {
  switch (key) {
    case "tbr":
      return "inclusionAgent.stats.TBR";
    case "tir":
      return "inclusionAgent.stats.TIR";
    case "cv":
      return "inclusionAgent.stats.CV";
    case "gmi":
      return "inclusionAgent.stats.GMI";
    case "hypo_count":
      return "inclusionAgent.stats.hypo_count";
  }
};

export type InclusionAgentPatientAccepted = BaseInclusionAgentInfo & {
  status: "patient_accepted";
};

export type InclusionAgentPatient = InclusionAgentDocSuggestion | InclusionAgentPatientAccepted;

const baseInclusionAgentInfoSchema: Schema<BaseInclusionAgentInfo> = cz.camelCaseObject({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  libreview_id: z.string(),
  email: cz.optional(z.string()),
  phone_number: cz.optional(z.string()),
});

export const inclusionAgentPatientModelSchema: Schema<InclusionAgentPatient> = z.intersection(
  z.discriminatedUnion("status", [
    cz.camelCaseObject({
      status: z.literal(["suggested_to_doc"]),
      TBR: cz.optional(z.number()),
      TIR: cz.optional(z.number()),
      CV: cz.optional(z.number()),
      GMI: cz.optional(z.number()),
      hypo_count: cz.optional(z.number()),
    }),
    z.object({
      status: z.literal(["patient_accepted"]),
    }),
  ]),
  baseInclusionAgentInfoSchema,
);
